import React, { useEffect } from 'react';
import { useBots } from '../hooks';
import GeckoStore from 'services/gecko-store';
import GeckoLocation from 'services/gecko-location';

function BotsRoute() {
  const [bots, isLoading] = useBots();
  const openBot = (id) => {
    GeckoLocation.goTo(`/bots/${id}/answers`);
  };
  const redirectToNew = () => {
    GeckoLocation.goTo(`/bots/new/settings`);
  };
  useEffect(() => {
    if (!bots.length && isLoading) {
      return;
    }
    if (!bots.length) {
      return redirectToNew();
    }
    const lastOpenedBotId = Number(
      GeckoStore.localStorage.get('last-opened-bot')
    );
    const lastBot = bots.find((bot) => bot.id === lastOpenedBotId);
    if (lastBot) {
      openBot(lastOpenedBotId);
    } else {
      openBot(bots[0].id);
    }
  }, [bots, isLoading]);
  return <p>Pick a bot</p>;
}

export default BotsRoute;
